import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import categoriaIcon from "../../assets/icons/despesas.png";
import CategoriasDespesasService from "../../services/DespesasCategoriasService";

export default function CategoriaDespesasForm({
  itemSelecionado,
  modo,
  onSubmit,
  onClose,
}) {
  const [form, setForm] = useState({
    idCategoriaDespesa: null,
    descricao: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idCategoriaDespesa: null,
        descricao: "",
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idCategoriaDespesa: itemSelecionado.IDCATEGORIADESPESA,
        descricao: itemSelecionado.DESCRICAO || "",
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};
    if (!form.descricao) e.descricao = "Informe a descrição";
    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        const payload_create = {
          DESCRICAO: form.descricao,
        };

        await CategoriasDespesasService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Categoria de Despesa criada com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {
        const payload_update = {
          IDCATEGORIADESPESA: form.idCategoriaDespesa,
          DESCRICAO: form.descricao,
        };

        await CategoriasDespesasService.update(
          form.idCategoriaDespesa,
          payload_update
        );

        setRetorno({
          tipo: "sucesso",
          mensagem: "Categoria de Despesa atualizada com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar a Categoria de Despesa."
            : "Erro ao atualizar Categoria de Despesa.",
      });
      setSubmitState("ERROR");
      onClose();
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={categoriaIcon} alt="categoria despesa" className="icon" />
          {modo === "novo"
            ? "Cadastro de Categoria de Despesa"
            : "Alterar Categoria de Despesa"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição: *</div>
          <input
            name="descricao"
            value={form.descricao}
            onChange={handleChange}
          />
          {errors.descricao && (
            <span style={{ color: "red" }}>{errors.descricao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Enviando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
